import find from "lodash/find"

export default (mapMarkers, searchId) => {
  const mapMarker = find(mapMarkers, [`uniqueId`, searchId])
  return mapMarker !== undefined ? mapMarker.position : null
}
